// Copyright (c) 2015-present, salesforce.com, inc. All rights reserved

import { combineReducers } from 'redux';
import { requestsReducer } from 'redux-requests';

import currentPageReducer from './currentPageReducer';
import restoreStatusReducer from './restoreStatusReducer';
import accessTokenReducer from './accessTokenReducer';
import userInfoReducer from './userInfoReducer';
import tokenValidationErrorReducer from './tokenValidationErrorReducer';
import languageReducer from './languageReducer';
import langChangedReducer from './langChangedReducer';

const rootReducer = combineReducers({
	requests: requestsReducer,
	currentPage: currentPageReducer,
	restoreStatus: restoreStatusReducer,
	accessToken: accessTokenReducer,
	userInfo: userInfoReducer,
	tokenValidationError: tokenValidationErrorReducer,
	language: languageReducer,
	langChanged: langChangedReducer
});

export default rootReducer;
